import { useState, useEffect } from 'react';
import {
  Stack,
  FormControl,
  FormLabel,
  HStack
} from '@chakra-ui/react';
import SearchBar from '../../SearchBar/SearchBar';
import StatusDropdown from '../../Dropdown/StatusDropdown/StatusDropdown';
import ArtistDropdown from '../../Artist/ArtistDropdown/ArtistDropdown';
import { ProcessStatus } from 'models/types';
import { ArtistModel } from 'models';

export interface MergeFiltersFormProps {
  defaultStatus?: ProcessStatus;
  defaultQuery?: string;
  defaultArtists?: ArtistModel[];
  availableArtists?: ArtistModel[];
  onStatusChange: (status: ProcessStatus) => void;
  onQueryChange: (query: string) => void;
  onArtistChange: (artists: ArtistModel[]) => void;
}

export default function MergeFiltersForm({
  defaultStatus = ProcessStatus.PENDING,
  defaultQuery = '',
  defaultArtists = [],
  availableArtists = [],
  onStatusChange,
  onQueryChange,
  onArtistChange
}: MergeFiltersFormProps) {
  const [selectedStatus, setSelectedStatus] = useState<ProcessStatus>(defaultStatus);
  const [query, setQuery] = useState<string>(defaultQuery);
  const [selectedArtists, setSelectedArtists] = useState<ArtistModel[]>(defaultArtists);

  // Sync internal state with prop changes
  useEffect(() => {
    setSelectedStatus(defaultStatus);
  }, [defaultStatus]);

  useEffect(() => {
    setQuery(defaultQuery);
  }, [defaultQuery]);

  useEffect(() => {
    setSelectedArtists(defaultArtists);
  }, [defaultArtists]);

  const handleStatusChange = (status: ProcessStatus) => {
    setSelectedStatus(status);
    onStatusChange(status);
  };

  const handleQueryChange = (value: string) => {
    setQuery(value);
    onQueryChange(value);
  };

  const handleArtistChange = (artists: ArtistModel[]) => {
    setSelectedArtists(artists);
    onArtistChange(artists);
  };

  return (
    <Stack spacing={4}>
      <HStack spacing={4} alignItems="flex-end">
        <FormControl flex={2}>
          <SearchBar
            onChange={handleQueryChange}
            defaultValue={defaultQuery}
          />
        </FormControl>
        <FormControl flex={1}>
          <FormLabel fontSize="sm" htmlFor="merge-artist">Artist</FormLabel>
          <ArtistDropdown
            artists={availableArtists}
            onArtistSelect={handleArtistChange}
            defaultSelectedArtists={selectedArtists}
            multiSelectable={true}
            maxWidth={true}
          />
        </FormControl>
        <FormControl flex={1}>
          <FormLabel fontSize="sm" htmlFor="merge-status">Status</FormLabel>
          <StatusDropdown
            value={selectedStatus}
            onChange={handleStatusChange}
            size="md"
          />
        </FormControl>
      </HStack>
    </Stack>
  );
}
